var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "guide",
      class: [
        _vm.size ? "guide-" + _vm.size : "",
        { "not-subscribe": _vm.notSubscribe },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "guide__tags" },
        [
          _c("Tag", {
            attrs: { text: "REPORT", background: "brown", link: "/reports" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.date
        ? _c(
            "div",
            { staticClass: "guide__date" },
            [_c("Date", { attrs: { text: _vm.date, author: _vm.author } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "guide-bottom" }, [
        _vm.download
          ? _c(
              "div",
              { staticClass: "guide__download" },
              [_c("Download", { attrs: { file: _vm.download } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "guide__title" },
        [
          _c(
            "nuxt-link",
            { staticClass: "guide__title-link", attrs: { to: _vm.link } },
            [_vm._v(_vm._s(_vm.title))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.desc
        ? _c("div", { staticClass: "guide__desc" }, [_vm._v(_vm._s(_vm.desc))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "nuxt-link",
        { staticClass: "guide__arrow-link", attrs: { to: _vm.link } },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "11.911",
                height: "9",
                viewBox: "0 0 11.911 9",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "Arrow",
                  d: "M17.793,131.582h0l-4.071-4.071a.407.407,0,1,0-.574.574l3.375,3.379H6.407a.407.407,0,0,0,0,.814H16.523l-3.375,3.375a.407.407,0,1,0,.574.574l4.071-4.071A.407.407,0,0,0,17.793,131.582Z",
                  transform: "translate(-6 -127.369)",
                  fill: "#003d6a",
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }